export enum WidgetType {
    COLLECT_EMAIL = 'collect-email',
}